export const Zones = {
  NAVIGATION: 'navigation',
  TOOLS_MAIN: 'tools-main',
  TOOLS_SECONDARY: 'tools-secondary',
  HIDDEN_ZONE: 'hidden-zone',
  MENU_TOP_LEFT: 'menu-top-left'
};
